/**
 * Settings-related constants
 */

export const LANGUAGES = [
  { code: "en", name: "settings.english" },
  { code: "am", name: "settings.amharic" },
  { code: "ti", name: "settings.tigrinya" },
] as const;

export const ACCESSIBILITY_OPTIONS = [
  {
    key: "highContrast" as const,
    label: "settings.highContrast",
    description: "settings.highContrastDescription",
  },
  {
    key: "reducedMotion" as const,
    label: "settings.reducedMotion",
    description: "settings.reducedMotionDescription",
  },
  {
    key: "largeText" as const,
    label: "settings.largeText",
    description: "settings.largeTextDescription",
  },
] as const;

export const PRIVACY_OPTIONS = [
  {
    key: "shareProgress" as const,
    label: "settings.shareProgress",
    description: "settings.shareProgressDescription",
  },
  {
    key: "showProfile" as const,
    label: "settings.showProfile",
    description: "settings.showProfileDescription",
  },
  {
    key: "allowMessages" as const,
    label: "settings.allowMessages",
    description: "settings.allowMessagesDescription",
  },
] as const;

export const NOTIFICATION_CHANNELS = [
  {
    key: "email" as const,
    label: "settings.emailNotifications",
    description: "settings.emailNotificationsDescription",
  },
  {
    key: "push" as const,
    label: "settings.pushNotifications",
    description: "settings.pushNotificationsDescription",
  },
  {
    key: "sms" as const,
    label: "settings.smsNotifications",
    description: "settings.smsNotificationsDescription",
  },
] as const;

export const NOTIFICATION_TYPES = [
  {
    key: "courseAssignments" as const,
    label: "settings.courseAssignments",
    description: "settings.courseAssignmentsDescription",
  },
  {
    key: "deadlineReminders" as const,
    label: "settings.deadlineReminders",
    description: "settings.deadlineRemindersDescription",
  },
  {
    key: "achievements" as const,
    label: "settings.achievements",
    description: "settings.achievementsDescription",
  },
  {
    key: "systemUpdates" as const,
    label: "settings.systemUpdates",
    description: "settings.systemUpdatesDescription",
  },
] as const;

export const SETTINGS_SECTIONS = [
  {
    id: "account",
    label: "settings.account",
    description: "settings.accountDescription",
  },
  {
    id: "privacy",
    label: "settings.privacy",
    description: "settings.privacyDescription",
  },
  {
    id: "notifications",
    label: "settings.notifications",
    description: "settings.notificationsDescription",
  },
  {
    id: "appearance",
    label: "settings.appearance",
    description: "settings.appearanceDescription",
  },
  {
    id: "security",
    label: "settings.security",
    description: "settings.securityDescription",
  },
] as const;
